module.exports = __webpack_public_path__ + "static/media/settings-gears.f742b188.svg";